module.exports = __webpack_public_path__ + "b1fe389b09ff7000fd5700420fe424a4.png";